import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            吃瓜速递
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            最新网红动态第一时间推送，台北娜娜、莫里秀、玩偶姐姐热门人物资讯全覆盖
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.slice(0, 6).map((card) => {
            const tagColorMap: Record<string, string> = {
              accent: 'bg-accent-100 text-accent-700',
              primary: 'bg-primary-100 text-primary-700',
              secondary: 'bg-secondary-100 text-secondary-700',
            };
            return (
              <article
                key={card.id}
                className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200/60 transition-all cursor-pointer"
              >
                <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-medium ${tagColorMap[card.tagColor] || tagColorMap.primary}`}>
                      {card.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="font-medium text-foreground-900 text-sm md:text-base mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {card.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                    {card.summary}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-400">{card.date}</span>
                    <span className="text-xs text-primary-600 font-medium flex items-center gap-1">
                      查看详情 <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
                    </span>
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        {cardsData.length > 6 && (
          <div className="mt-6">
            <article className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200/60 transition-all cursor-pointer">
              <div className="flex flex-col sm:flex-row">
                <div className="relative w-full sm:w-2/5 aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-100">
                  <img
                    src={cardsData[6].image}
                    alt={cardsData[6].title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700">
                      {cardsData[6].tag}
                    </span>
                  </div>
                </div>
                <div className="flex-1 p-4 md:p-6 flex flex-col justify-center">
                  <h3 className="font-medium text-foreground-900 text-base md:text-lg mb-2 group-hover:text-primary-600 transition-colors">
                    {cardsData[6].title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                    {cardsData[6].summary}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-400">{cardsData[6].date}</span>
                    <span className="text-xs text-primary-600 font-medium flex items-center gap-1">
                      查看详情 <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
                    </span>
                  </div>
                </div>
              </div>
            </article>
          </div>
        )}
      </div>
    </section>
  );
}